module.exports = __webpack_public_path__ + "static/media/bkst_site_product.8413c2da.jpg";